var _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRingsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 48,
    viewBox: "0 0 84 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.8144,
    cy: 23.8144,
    r: 23.8144,
    fill: "white",
    fillOpacity: 0.58
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 23.8144,
    r: 23.8144,
    fill: "white",
    fillOpacity: 0.58
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.1856,
    cy: 23.8144,
    r: 23.8144,
    fill: "white",
    fillOpacity: 0.58
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRingsIcon);
export default __webpack_public_path__ + "static/media/ringsIcon.b36394bbd81301c3a209026ef99e934a.svg";
export { ForwardRef as ReactComponent };